/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditordishdescription3Inputs */

const en_menueditordishdescription3 = /** @type {(inputs: Menueditordishdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const de_menueditordishdescription3 = /** @type {(inputs: Menueditordishdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Menueditordishdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditordishdescription3 = /** @type {((inputs?: Menueditordishdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditordishdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditordishdescription3(inputs)
	return de_menueditordishdescription3(inputs)
});
export { menueditordishdescription3 as "menuEditorDishDescription" }